var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4964 7.65767C12.8717 8.15027 11.9097 8.106 11.3475 7.55871L7.00069 3.32688L2.65241 7.55872C2.09015 8.10588 1.12815 8.15024 0.503531 7.65768C-0.120908 7.16505 -0.171499 6.32212 0.390589 5.77483L5.86829 0.441413C6.15688 0.160456 6.56929 -3.04061e-07 7.00069 -3.41775e-07C7.43187 0.000146486 7.84314 0.160585 8.1316 0.441412L13.6093 5.77483C14.1715 6.32216 14.121 7.16505 13.4964 7.65767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c13cd44ee3e4427913099b5d4b72d227.svg";
export { ForwardRef as ReactComponent };